import React, { useState, useEffect, useRef } from "react";
import { InstantSearch, connectHits, Configure } from "react-instantsearch-dom";
import { A11y, Navigation } from "swiper";
import { searchClient } from '@/utils/algolia-search-client';

// const searchClient = algoliasearch(
//   process.env.ALGOLIA_APPLICATION_ID,
//   process.env.ALGOLIA_SEARCH_API_KEY
// );
import ProductItemTile from "../ProductItemTile";
import styles from "../ProductItem/ProductItem.module.scss";
import Srcset from "@/components/common/Srcset";
import { Swiper, SwiperSlide } from "swiper/react";
import { useDispatch, useSelector } from "react-redux";
import { showPwaLoader } from "@/redux/actions/pwaAction";

const Hits = ({ hits }) => {
  return (
    <>
      <div className="ais-Hits">
        <ul className="ais-Hits-list">
          {hits.map((hit) => {
            if (hit.title) {
              return (
                <li key={hit.objectID} className="ais-Hits-item">
                  <ProductItemTile hit={hit} searchComp={true}  />
                </li>
              );
            }
          })}
        </ul>
      </div>
    </>
  );
};
const redirectSearch = (query) => {


  window.location.replace(`/search?query=${query}`);
}
function stripTags(original) {
  return original.replace(/(<([^>]+)>)/gi, "");
}
const SuggestionHits = (props) => {
  const [swiper, setSwiper] = useState();
  const prevRef = useRef();
  const nextRef = useRef();
  const dispatch = useDispatch();
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  useEffect(() => {
    if (swiper) {
      swiper.params.navigation.prevEl = prevRef.current;
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation.init();
      swiper.navigation.update();
    }
  }, [swiper]);

  const { hits, autocomplete } = props;
  if (hits.length) {
    return (
      <div className={`${styles.suggestion_container}`}>
        <div className={`swiper-button ${styles.swiper_prev}`} ref={prevRef}>
          <Srcset
            svgFile={true}
            requirePath={true}
            alt="right-arrow"
            width="12"
            height="10"
            src={"images/Icons/Arrow/Right/Large_dark.svg"}
          />
        </div>
        <Swiper
          slidesPerView={"auto"}
          speed={500}
          slidesPerGroup={3}
          spaceBetween={20}
          loop={true}
          draggable={true}
          className={`${styles.aa_suggestions_wrapper} ${styles.swiper}`}
          navigation={{
            prevEl: prevRef?.current,
            nextEl: nextRef?.current,
          }}
          modules={[Navigation, A11y]}
          scrollbar={{ draggable: true }}
          onSwiper={setSwiper}
        >
          {hits.map((hit) => (
            <SwiperSlide key={hit.query} className={`${styles.swiper_slide}`}>
              <div className={`${styles.aa_suggestions_highlight} x-small medium`}
                onClick={() => {
                  (redirectSearch(stripTags(hit.query)));
                  if(isPWA) {
                    dispatch(showPwaLoader(true))
                  }
                }}
      >
                {hit.query}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className={`swiper-button ${styles.swiper_next}`} ref={nextRef}>
          <Srcset
            svgFile={true}
            requirePath={true}
            alt="right-arrow"
            height="12"
            width="12"
            src={"images/Icons/Arrow/Right/Large_dark.svg"}
          />
        </div>
      </div>
    );
  }
  return null
};
const Popular = (props) => {

  const CustomHits = connectHits(Hits);
  const CostomSuggesionHits = connectHits(SuggestionHits)
  return (
    <div className={`${styles.no_search}`}>
      <span>{`Sorry, there are no results for '${props.query}'`}</span>
      <div className={`${styles.suggestion_title} x-large-xs large-sm large-md light`}>
        <span>Most popular searches</span>
      </div>
      <InstantSearch
        indexName={process.env.SHOPIFY_QUERY_SUGGESTIONS_INDEX}
        searchClient={searchClient}
      >
        <Configure hitsPerPage={10} />
        <CostomSuggesionHits autocomplete={props.autocomplete} />
      </InstantSearch>
      <div className="ais-InstantSearch">
        <InstantSearch
          indexName={process.env.SHOPIFY_RECENTLY_ORDERED_INDEX}
          searchClient={searchClient}
        >
          <Configure hitsPerPage={10} />
          <CustomHits />
        </InstantSearch>
      </div>
    </div>
  );
};

export default Popular;
